import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAnchorEl } from '../../../components/hooks/useAnchorEl';
import { Menu, MenuItem } from '../../../components/material-ui/Menu';
import { AppBar } from '../../../components/material-ui/AppBar';
import { Button } from '../../../components/material-ui/Button';
import { useStyles } from './useStyles';
import { Toolbar } from '../../../components/material-ui/Toolbar';
import { Typography } from '../../../components/material-ui/Typography';

export const ReportDropzoneImage = memo((props) => {
    const { src, height, className, onDeleteImage, enableFullScreenMode = true, pos, isNew, quickShow = false } = props;
    const [anchorEl, handleOpenMenu, handleClose] = useAnchorEl();
    const classes = useStyles();
    const [fullScreen, changeFullScreen] = React.useState(false);
    const { t: translate } = useTranslation();
    const handleToggleFullScreen = React.useCallback(
        () =>
            changeFullScreen((prevState) => {
                handleClose();

                return !prevState;
            }),
        []
    );

    const handleDeleteImage = React.useCallback(() => {
        onDeleteImage(pos, isNew);
        handleClose();
    }, [pos, isNew]);

    const handleClickPreview = React.useCallback(
        (event) => {
            event.preventDefault();
            if (quickShow) {
                handleToggleFullScreen();
            } else {
                handleOpenMenu(event);
            }
        },
        [quickShow]
    );

    return (
        <>
            {fullScreen ? (
                <div className={classes.image}>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" className={classes.title} color="inherit">
                                {translate('reports.reportDetails')}
                            </Typography>
                            <Button color="inherit" onClick={handleToggleFullScreen}>
                                {translate('ok')}
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.inner} style={{ backgroundImage: `url(${src})` }}></div>
                </div>
            ) : (
                <img className={className} onClick={handleClickPreview} height={height} src={src} />
            )}
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {enableFullScreenMode && <MenuItem onClick={handleToggleFullScreen}>{translate('show')}</MenuItem>}
                {onDeleteImage && <MenuItem onClick={handleDeleteImage}>{translate('delete')}</MenuItem>}
            </Menu>
        </>
    );
});
